module.exports = __webpack_public_path__ + "static/media/2-mobile.a7bd5580.jpg";